import { render, staticRenderFns } from "./nonStandard.vue?vue&type=template&id=51756b6e&scoped=true&"
import script from "./nonStandard.vue?vue&type=script&lang=js&"
export * from "./nonStandard.vue?vue&type=script&lang=js&"
import style0 from "./nonStandard.vue?vue&type=style&index=0&id=51756b6e&lang=scss&scoped=true&"
import style1 from "./nonStandard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51756b6e",
  null
  
)

export default component.exports